<span class="text-xs text-gray-300">
  <ng-content></ng-content>
</span>
